import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {AddClientCommand, EditMailingPermitCommand, EditOrganizationCommand, OrgLogoCommandDto, Organization, UserItem } from "../../api/models/schema";
import { useApi } from "../../hooks/useApi";
import { addClientApi,  editOrgMailingPermitApi, editOrganizationApi,getOrganizationApi, setOrgLogoApi,} from "../../api/liveMarketingApi";
import {CircularProgress} from "@mui/material";
import { OrganizationHeader } from "./organization/organizationHeader";
import { OrganizationContext } from "../../context/organizationContext";
import { AppUserContext } from "../../context/appUserContext";
import { ClientData } from "./client/clientData";

export function DashboardPage() {

  //state
  
  const [organization, setOrganization] = useState<Organization | undefined>(undefined);

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { appUser } = useContext(AppUserContext);

  //Nav hooks
  const params = useParams();
  const navigate = useNavigate();

  //Api hooks
  const getOrganizationRequest = useApi(getOrganizationApi);
  const editOrgRequest = useApi(editOrganizationApi);
  const addClientRequest = useApi(addClientApi);
  const editOrgMailingPermitRequest = useApi(editOrgMailingPermitApi);
  const setOrgLogoRequest = useApi(setOrgLogoApi);

  if (!appUser) {
    navigate(`/login`);
  }

  useEffect(() => {
    if (appUser) {
      refreshPage();
    }
  }, [appUser]);

  // Organization Effects
  useEffect(() => {

    if (getOrganizationRequest.data) {
      setOrganization(getOrganizationRequest.data);
    }

  }, [getOrganizationRequest.data]);

  useEffect(() => {
    if (getOrganizationRequest.error) {
      //todo: pass the error to the correct location
    }
  }, [getOrganizationRequest.error]);

  useEffect(() => {

    if (editOrgRequest.data) {
      refreshPage();
    }

  }, [editOrgRequest.data]);

  useEffect(() => {
    if (editOrgRequest.error) {
      //todo: pass the error to the correct location
    }
  }, [editOrgRequest.error]);

  useEffect(() => {

    if (editOrgMailingPermitRequest.data) {
      refreshPage();
    }

  }, [editOrgMailingPermitRequest.data]);

  useEffect(() => {
    if (editOrgMailingPermitRequest.error) {
      //todo: pass the error to the correct location
    }
  }, [editOrgMailingPermitRequest.error]);

  useEffect(() => {

    if (addClientRequest.data) {
      refreshPage();
    }

  }, [addClientRequest.data]);

  useEffect(() => {
    if (addClientRequest.error) {
      //todo: pass the error to the correct location
    }
  }, [addClientRequest.error]);

  useEffect(() => {

    if (setOrgLogoRequest.data) {
      refreshPage();
    }

  }, [setOrgLogoRequest.data]);

  useEffect(() => {
    if (setOrgLogoRequest.error) {
      //todo: pass the error to the correct location
    }
  }, [setOrgLogoRequest.error]);

  

 function refreshPage(){
   getOrganizationRequest.request(params.orgId, appUser?.appUserName);
}

function updateOrganization(editOrganization: EditOrganizationCommand){
    editOrgRequest.request(params.orgId,editOrganization, appUser?.appUserName);
  }

  function updateMailingPermit(editMailingPermit: EditMailingPermitCommand){
    editOrgMailingPermitRequest.request(params.orgId,organization?.mailingPermit.mailingPermitId,editMailingPermit, appUser?.appUserName, null, null);
  }

  function addClient(addClient: AddClientCommand){
    addClientRequest.request(params.orgId, addClient, appUser?.appUserName);
  }

  function updateLogo(logoCommand: OrgLogoCommandDto){
    setOrgLogoRequest.request(params.orgId, logoCommand, appUser?.appUserName);
  }


  function displayPageData(){
    return (
      <>
      <OrganizationHeader />
      <ClientData />
      </>
    );
  }

    return (
      <>
      
        <OrganizationContext.Provider value={
          {organization, updateOrganization,
          updateMailingPermit, addClient, updateLogo ,errorMessage, isLoading
          }}>
        {getOrganizationRequest.loading && <CircularProgress />}
        {!getOrganizationRequest.loading && organization && displayPageData()}
        </OrganizationContext.Provider>

       
      </>
    
  );
}
